export const ACTIONS_CODES_FOR_COMMENT_MODAL = [
    'SEND_FOR_AGREE',
    'SUBMIT_FOR_PRELIMINARY_VERIFICATION',
    'RETURN_TO_WORK',
    'REJECT_CHECK_DOCUMENTS',
    'REJECT_AGREE',
    'PUBLIC',
    'DELETE',
    'DELAYED_PUBLICATION',
    'CHECK_DOCUMENTS',
    'CANCEL_PUBLIC',
    'AGREE',
];

export const ACTIONS_CODES_FOR_SENDING_ROW_IDS = [
    'SEND_TO_DELETION_SECTION',
    'RESTORE_DOCUMENT',
];
